import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';
import { EMPTY, catchError, switchMap, throwError } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const adminService = inject(AdminService);
  const modalService = inject(NgbModal);
  const token = localStorage.getItem('@administrator');

  function isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp < currentTime;
    } catch {
      return true;
    }
  }

  let authReq = req;

  if (token) {
    const expired = isTokenExpired(token);
    console.log(`[Interceptor] Token found. Expired: ${expired}`);

    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true
    });
  } else {
    console.log('[Interceptor] No token found.');
  }

  console.log('[Interceptor] Proceeding with request to:', authReq.url);

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401 && !isRefreshing) {
        console.warn('[Interceptor] Unauthorized response received. Trying refresh.');
        isRefreshing = true;

        return adminService.refreshToken().pipe(
          switchMap((res: any) => {
            const newToken = res.access_token;
            if (newToken) {
              localStorage.setItem('@administrator', newToken);
              const retryReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                },
                withCredentials: true
              });
              isRefreshing = false;
              return next(retryReq);
            } else {
              throw new Error('No new token in refresh response');
            }
          }),
          catchError((refreshError) => {
            console.error('[Interceptor] Refresh token failed', refreshError);
            isRefreshing = false;
            modalService.dismissAll();
            adminService.logout(true);
            return throwError(() => refreshError);
          })
        );
      }

      return throwError(() => error);
    })
  );
};